import { WidgetProps } from '@highimpact-front/remote-widget-core';
import { forwardRef, useMemo, type LegacyRef } from 'react';
import { getWidgetAtKey } from '../../../state/store-operations';
import { WidgetConfigContext } from './WidgetConfigContext';

import { useDashboardLibrarySelector } from '../../../runtime/DashboardLibraryProvider';
function Widget(
  { children, widget_id, className, is_editable, ...props }: WidgetProps,
  ref: LegacyRef<HTMLDivElement>
) {
  const widgetIsOnConfig = useDashboardLibrarySelector((state) => {
    const panel = state.dashboard.ConfigWidgetPanelState;

    if (panel.state !== 'Configuring' && panel.state !== 'Reconfiguring') {
      return false;
    }

    const dashboard = state.dashboard.grids[panel.gridId];
    if (!dashboard) {
      return false;
    }

    const comparedWidget = getWidgetAtKey(
      widget_id,
      dashboard
    )?.dashboardElementId;
    return Number(panel.widgetId) === Number(comparedWidget);
  });

  const configContextValue = useMemo(
    () => ({ widgetIsOnConfig }),
    [widgetIsOnConfig]
  );

  return (
    <WidgetConfigContext.Provider value={configContextValue}>
      <div
        {...props}
        ref={ref}
        id={`widget-${widget_id}`}
        className={`widget ${className || ''} ${
          widgetIsOnConfig ? 'widget-config' : ''
        }`}
      >
        {children}
      </div>
    </WidgetConfigContext.Provider>
  );
}

export default forwardRef(Widget);
